import { Optional } from '@app/@types/common'

export const zwaveSensorValueTypes = (type: Optional<string>, value: Optional<boolean>) => {
  const zwaveSensorsTypeMap = {
    'Door/Window': value ? 'Unsealed' : 'Sealed',
    Motion: value && 'Detected',
    Tamper: value && 'Detected',
    default: '',
  }

  // @ts-ignore TS5: index expression on typed object
  return (type && zwaveSensorsTypeMap[type]) || zwaveSensorsTypeMap.default
}
